__turbopack_context__.v({
  "category": "q5ZVWW_category",
  "grid": "q5ZVWW_grid",
  "grid_0": "q5ZVWW_grid_0",
  "grid_1": "q5ZVWW_grid_1",
  "grid_2": "q5ZVWW_grid_2",
  "grid_3": "q5ZVWW_grid_3",
  "grid_4": "q5ZVWW_grid_4",
  "grid_5": "q5ZVWW_grid_5",
  "grid_6": "q5ZVWW_grid_6",
  "logo__bottom": "q5ZVWW_logo__bottom",
  "newsletter": "q5ZVWW_newsletter",
  "sanity": "q5ZVWW_sanity",
});
